module.exports = __webpack_public_path__ + "static/media/mail.07edc7d2.svg";